/** @jsxImportSource @emotion/react */
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import { useGetSplitConfigurations } from "../../service/adyen-account-holders-api";
import { Divider } from "../../../../components/Divider";
import { CardBody } from "../../../../components/page-skeleton/CardBody";
import { css } from "@emotion/react";
import { EmptyState } from "../../../../components/EmptyState";
import { PageFooter } from "../../../../components/page-skeleton/PageFooter";
import { StyledText } from "../../../../assets/typography/typography";
import { SpinnerBlock } from "../../../common/Spinner";
import { AdyenSplitConfigurationsTable } from "./AdyenSplitConfigurationsTable";

const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

export const AdyenSplitConfigurations = () => {
  const { data: splitConfigurations, isLoading } = useGetSplitConfigurations();

  if (isLoading || !splitConfigurations) {
    return <SpinnerBlock />;
  }

  return (
    <CardContainer>
      <PageHeader
        title="Split configurations"
        subtitle="You can see all of your split configurations for this account holder. Should be created in Adyen admin"
      />
      {splitConfigurations?.length === 0 ? (
        <>
          <Divider />
          <CardBody additionalStyles={cardBodyAdditionalStyling}>
            <EmptyState
              title="No split configurations created yet"
              subtitle="Create one in Adyen admin."
            />
          </CardBody>
        </>
      ) : (
        <div>
          <AdyenSplitConfigurationsTable
            splitConfigurations={splitConfigurations}
          />
          <PageFooter>
            <StyledText className="bodyTextRegular mb-0">
              {splitConfigurations.length}{" "}
              {splitConfigurations.length === 1
                ? "split configuration"
                : "split configurations"}{" "}
              in total
            </StyledText>
          </PageFooter>
        </div>
      )}
    </CardContainer>
  );
};
